var version = {
    "name":      "dativery",
    "buildDateCode": "20251218-095024",
    "buildDate": "Thu Dec 18 2025 09:50:24 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251218-095024",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;